import React from 'react';

import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import { setCookieForMembers } from '../../../src/client/utils/cookie-for-members';
import config from '../../../src/client/config';
import getInsuranceTypeFromLocation from '../../../src/client/pages/insurance/utils/get-insurance-type-from-location';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import RedirectAdapter from '../../../src/client/utils/redirect-adapter';

export const getStaticPaths = () => getStaticPathsForInsuranceTypes([INSURANCE_TYPES.CAR, INSURANCE_TYPES.HOME]);

// @ts-expect-error - Automatic, Please fix when editing this file
export const getStaticProps = ({ params: { insuranceType } }) => ({ props: { location: insuranceType } });

const SALES_URL = config.get('sales:url');
const PORTAL_LOGIN_PAGE = config.get('open:portalUrl');
const API_TOKEN = config.get('open:apiToken');

type Props = {
  location: 'car-insurance' | 'home-insurance';
};

const CarAndHomeLoginPage = ({ location }: Props) => {
  const insuranceType = getInsuranceTypeFromLocation(location);
  const portalLoginWithParams = `${PORTAL_LOGIN_PAGE}/login?partner=${API_TOKEN}&redirect=${SALES_URL}`;
  setCookieForMembers(insuranceType);
  return <RedirectAdapter to={portalLoginWithParams} />;
};

export default CarAndHomeLoginPage;
